import { motion } from "framer-motion";
import { Home, Waves, Clock, Shell, Tv, Car } from "lucide-react";

const t = {
  es: {
    label: "Nuestros Servicios",
    title: "Todo lo que necesitas",
    titleAccent: "para una estadía perfecta",
    services: [
      {
        icon: Home,
        title: "Hospedaje",
        desc: "Lugares acogedores para relajarse, divertirse y desconectarse del día a día.",
      },
      {
        icon: Waves,
        title: "Piscina",
        desc: "Amplia piscina para refrescarse toda la familia, para chicos y grandes.",
      },
      {
        icon: Clock,
        title: "Horarios Flexibles",
        desc: "Podemos ser flexibles con los horarios para ayudarte a planificar mejor.",
      },
      {
        icon: Shell,
        title: "Acceso a la Playa",
        desc: "A tan solo 5 minutos caminando al mar desde el complejo.",
      },
      {
        icon: Tv,
        title: "TV en Bungalow",
        desc: "Cada bungalow cuenta con televisión para que no te pierdas nada.",
      },
      {
        icon: Car,
        title: "Parqueo Seguro",
        desc: "Área de parqueo privado y seguro dentro del complejo.",
      },
    ],
  },
  en: {
    label: "Our Services",
    title: "Everything you need",
    titleAccent: "for a perfect stay",
    services: [
      {
        icon: Home,
        title: "Accommodation",
        desc: "Cozy places to relax, have fun, and disconnect from daily life.",
      },
      {
        icon: Waves,
        title: "Swimming Pool",
        desc: "Large pool for the whole family to cool off, kids and adults alike.",
      },
      {
        icon: Clock,
        title: "Flexible Hours",
        desc: "We can be flexible with schedules to help you plan better.",
      },
      {
        icon: Shell,
        title: "Beach Access",
        desc: "Just 5 minutes walking to the ocean from the complex.",
      },
      {
        icon: Tv,
        title: "TV in Bungalow",
        desc: "Each bungalow has a television so you don't miss anything.",
      },
      {
        icon: Car,
        title: "Secure Parking",
        desc: "Private and secure parking area inside the complex.",
      },
    ],
  },
};

export default function Services({ lang }) {
  const tr = t[lang];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-28 bg-[#FAFAF9]"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="font-montserrat text-[#8C5E35] text-sm font-semibold tracking-widest uppercase mb-4"
          >
            {tr.label}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-montserrat font-extrabold text-[#1F3A5E] text-4xl md:text-5xl leading-tight"
            data-testid="services-title"
          >
            {tr.title}{" "}
            <span className="text-[#8C5E35]">{tr.titleAccent}</span>
          </motion.h2>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tr.services.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`service-card-${i}`}
              className="bg-white rounded-3xl p-8 border border-[#D4B895]/30 hover:border-[#D4B895]/60 hover:shadow-xl hover:shadow-[#1F3A5E]/5 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#1F3A5E]/5 flex items-center justify-center mb-5 group-hover:bg-[#1F3A5E]/10 transition-colors duration-300">
                <Icon size={22} className="text-[#1F3A5E]" />
              </div>
              <h3 className="font-montserrat font-bold text-[#1F3A5E] text-lg mb-2">
                {title}
              </h3>
              <p className="font-dm-sans text-gray-500 text-sm leading-relaxed">
                {desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
